'use strict';

/* global _ */

import { CalculatorTimberModel, CalculatorTimber } from './timber';

/**
 * Модель для хранения модели данных по необрезной доске
 */
class CalculatorUnedgedModel extends CalculatorTimberModel {
    calculateTimberPrice(){
        let self = this;

        let timber_length = self.get('timber_length');
        let timber_height = self.get('timber_height');
        let data = self.get('data');

        let price_item = _.find(data, function(item){
            return (((item.length_min <= timber_length) && (item.length_max >= timber_length)) && (item.height == timber_height)) ? true : false;
        });

        let price = 0;
        let price_id = 0;
        if(!_.isUndefined(price_item)){
            price = price_item.price;
            price_id = price_item.n;
        }
        self.set('price_id', price_id);
        self.set('price', price * self.get('timber_volume'));
    }
}

/**
 * Контроллер для калькулятора доски необрезной
 */
class CalculatorUnedged extends CalculatorTimber {

}

export {
    CalculatorUnedgedModel,
    CalculatorUnedged
};

